import Vue from "vue";
import VueRouter from "vue-router";

import Landing from "../views/Landing.vue";
import ErrorPage from "../views/ErrorPage.vue";

import ToolbarHc from "../views/hc_dashboard/ToolbarHc.vue";
import HcNewDashboard from "../views/hc_dashboard/HcDashboard_New.vue";
import HCDashboardItem_PowerBI from "../views/hc_dashboard/HCDashboardItem_PowerBI.vue";
import Department_Dashboard from "../views/hc_dashboard/HcDashboard_Department_PowerBI.vue";
import AcceptOfMoney from "../views/AcceptOfMoney.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "", //landing page from bot to web view
    name: "landing",
    component: Landing,
    props: route => ({ ...route.query }) //collected query after question mark ex. landing?shared_token=...
  },
  {
    path: "*",
    name: "error_page",
    component: ErrorPage
  },
  {
    path: "/pettycash_hc_dashboard",
    name: "pettycash_hc_dashboard",
    component: ToolbarHc,
    children: [
      {
        path: "/pettycash_hc_dashboard/dashboard",
        name: "hc_dashboard",
        component: HcNewDashboard
      },
      {
        path: "/pettycash_hc_dashboard/item_dashboard",
        name: "hc_dashboarditem",
        component: HCDashboardItem_PowerBI
      },
      {
        path: "/pettycash_hc_dashboard/department_dashboard",
        name: "department_dashboard",
        component: Department_Dashboard
      },
      // {
      //   path: "/accept_of_money",
      //   name: "accept_of_money",
      //   component: AcceptOfMoney
      // }
    ]
  },
  {
    path: "/accept_of_money",
    name: "accept_of_money",
    component: AcceptOfMoney
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
